<template>
  <div v-if="isOuterLoading" class="d-flex justify-content-center">
    <loader></loader>
  </div>

  <div v-else>
    <div class="row mb-2" v-if="room.guests.length > 1">
      <div class="col">
        <ul class="d-flex flex-row guest-list justify-content-center">
          <li
            class="mx-2"
            v-bind:class="{ on: activeGuestIndex == guestIndex }"
            v-for="(guest, guestIndex) in room.guests"
          >
            {{ guest.firstName }}
          </li>
        </ul>
      </div>
    </div>

    <!--<div class="row mb-2 ">
            <div class="col ">
                <h3>
                  Select {{activeGuestName}}'s treatment day
                    
                </h3>
            </div>
        </div>-->

    <div
      class="row mb-4 d-flex flex-row justify-content-center"
      v-if="stayDates.length"
    >
      <div
        class="col-xl-4 col-md-6 col-sm-8 col-12 current-date mx-2"
        v-bind:class="{ on: activeDateIndex == dateI }"
        v-for="(date, dateI) in stayDates"
      >
        <div class="text-uppercase">
          <strong>{{ formatDateLine1(date) }}</strong>
        </div>
        <div>
          {{ formatDateLine2(date) }}
        </div>
      </div>
    </div>

    <div v-if="isLoading" class="d-flex justify-content-center">
      <loader></loader>
    </div>
    <div>
      <div v-if="activePage == 'TREATMENTS'" class="row justify-content-center">
        <div class="modal-close p-0">
          <button class="btn btn--white" v-on:click="onClose()"></button>
        </div>

        <div class="col-24">
          <div class="row" v-if="dailyTreatments[activeDateIndex]?.treatments">
            <div
              class="col-24 col-xl-12 treatments"
              v-for="(treatment, dailyIndex) in dailyTreatments[activeDateIndex]
                .treatments"
            >
              <div
                class="bg-white spa-day-treatment-item justify-content-between row w-100 g-0"
              >
                <div class="col-24 col-xl-10 gallery g-0">
                  <single-image-gallery
                    v-bind:images="treatment.Images"
                  ></single-image-gallery>
                </div>
                <div class="col-24 col-xl-13 p-md-4 ps-md-2 p-3 item-wrapper">
                  <h4>{{ treatment.DisplayName }}</h4>

                  <div class="flex-grow-1 d-flex flex-column">
                    <div
                      class="item-description"
                      v-html="treatment.Description"
                      v-bind:class="{ on: treatment.expanded }"
                    ></div>

                    <div
                      class="btn-container d-flex justify-content-start flex-row"
                    >
                      <div
                        class=""
                        v-for="(duration, di) in treatment.Durations"
                      >
                        <button
                          type="button"
                          class="btn btn-treatment"
                          v-bind:class="{
                            on: isDurationSelected(treatment, duration),
                          }"
                          v-on:click="onSelectTreatment(treatment, duration)"
                        >
                          <span>{{ duration.Duration }}mins</span>
                          <div>
                            <span
                              class="d-block modal-price"
                              v-if="duration.IsIncluded"
                              >Included</span
                            >
                            <span class="d-block modal-price" v-else>
                              +&pound{{ duration.PriceDifference }}
                            </span>
                          </div>

                          <span class="modal-price"
                            >&pound;{{ duration.Price }}</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-8 modal-actions-bar">
          <div class="col-12 d-flex justify-content-start">
            <button
              class="btn btn--transparent btn--back"
              type="button"
              v-on:click="onClose()"
            >
              Close
            </button>
          </div>

          <div class="col-12 d-flex justify-content-end">
            <button
              class="btn btn--slate-blue btn--continue"
              type="button"
              v-bind:disabled="isDisabled"
              v-on:click="onNext()"
            >
              Continue
            </button>
          </div>
        </div>
      </div>

      <div v-else-if="'TIMES'" class="row justify-content-center">
        <div class="modal-close p-0">
          <button class="btn btn--white" @click="onClose()"></button>
        </div>

        <div
          class="row justify-content-center calendar"
          v-if="activeAvailableTimes && activeAvailableTimes.GuestAvailability"
        >
          <div class="row mb-4">
            <div class="col">
              <h3>Select {{ activeGuestName }}'s treatment time</h3>
            </div>
          </div>

          <div
            v-for="(
              clientAvailability, cai
            ) in activeAvailableTimes.GuestAvailability"
            v-bind:key="cai"
            class="col-24 col-xl-12 mb-4 calendar"
          >
            <div class="p-0 p-lg-2">
              <div class="row mb-4 button-wrapper">
                <div class="col-12">
                  <button
                    type="button"
                    class="btn btn--block modal-button"
                    v-bind:class="{
                      'modal-button--active':
                        (activeTimeOfDay == undefined &&
                          defaultTimeOfDay == 'AM') ||
                        activeTimeOfDay == 'AM',
                    }"
                    v-on:click="onSetTimeOfDay('AM')"
                  >
                    AM
                  </button>
                </div>
                <div class="col-12">
                  <button
                    type="button"
                    class="btn btn--block modal-button"
                    v-bind:class="{
                      'modal-button--active':
                        (activeTimeOfDay == undefined &&
                          defaultTimeOfDay == 'PM') ||
                        activeTimeOfDay == 'PM',
                    }"
                    v-on:click="onSetTimeOfDay('PM')"
                  >
                    PM
                  </button>
                </div>
              </div>
            </div>

            <div
              class="row times"
              v-if="
                (activeTimeOfDay == undefined && defaultTimeOfDay == 'AM') ||
                activeTimeOfDay == 'AM'
              "
            >
              <span
                class="col-12 col-lg-6 mb-3"
                v-on:click="onSelectTime(t)"
                v-for="(t, ca) in clientAvailability.Periods.AM"
                v-bind:key="ca"
              >
                <span
                  class="time-slot"
                  v-bind:class="{
                    'time-slot--active': isSelected(cai, t),
                    'timeslot--disabled': checkIsDisabled(t),
                  }"
                >
                  <span class="spa-time">{{ formatTime(t.StartTime) }}</span>
                </span>
              </span>
            </div>

            <div class="row times" v-else>
              <span
                class="col-12 col-lg-6 mb-3"
                v-on:click="onSelectTime(t)"
                v-for="(t, ca) in clientAvailability.Periods.PM"
                v-bind:key="ca"
              >
                <span
                  class="time-slot"
                  v-bind:class="{
                    'time-slot--active': isSelected(cai, t),
                    'timeslot--disabled': checkIsDisabled(t),
                  }"
                >
                  <span class="spa-time">{{ formatTime(t.StartTime) }}</span>
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="row mt-8 modal-actions-bar">
          <div class="col-12 d-flex justify-content-start">
            <button
              class="btn btn--transparent btn--back"
              type="button"
              v-on:click="onClose()"
            >
              Close
            </button>
          </div>

          <div class="col-12 d-flex justify-content-end">
            <button
              class="btn btn--slate-blue btn--continue"
              type="button"
              v-bind:disabled="isDisabled"
              v-if="canShowNext"
              v-on:click="onNext()"
            >
              Continue
            </button>

            <button
              class="btn btn--slate-blue btn--continue"
              v-bind:disabled="isDisabled"
              v-on:click="onSubmit()"
              v-else
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "../store/index";
import { _ } from "vue-underscore";

import Loader from "@/shared/components/Loader.vue";
import SingleImageGallery from "@/shared/components/SingleImageGallery.vue";
export default {
  name: "SpaPackageAvailability",
  props: {
    room: {
      type: Object,
      required: true,
    },
  },
  components: {
    Loader,
    SingleImageGallery,
  },
  computed: {
    activeGuestName() {
      return this.room?.guests[this.activeGuestIndex].firstName;
    },
    session() {
      return store.getters.session;
    },
    spaConfiguration() {
      return store.getters.spaConfiguration;
    },
    booking() {
      return store.getters.booking;
    },
    search() {
      return store.getters.search;
    },
    stayDates() {
      let result = [];

      if (this.search != null) {
        let seedDate = moment(this.search.arrivalDate).utcOffset(0, true);

        result.push(seedDate);

        if (+this.search.numberOfNights > 1) {
          for (let i = 1; i < +this.search.numberOfNights; i++) {
            let newDate = moment(seedDate).add(i, "d");

            result.push(newDate);
          }
        }
      }
      return result;
    },

    isDisabled() {
      if (this.activePage == "TREATMENTS") {
        return !this.hasTreatment;
      }
    },
    canShowNext() {
      if (this.activePage == "TREATMENTS") {
        return true;
      }

      if (this.room.guests.length == 1) {
        return false;
      }

      let moreGuests = this.room.guests.length > this.activeGuestIndex + 1;
      let moreDates = this.dailyTreatments.length > this.activeDateIndex + 1;

      if (moreDates) {
        return true;
      } else {
        return moreGuests;
      }

      return false;
    },
    hasTreatment() {
      let person = this.localSelections.filter(
        (item) =>
          item.guestIndex == this.activeGuestIndex &&
          item.dateIndex == this.activeDateIndex
      );

      return person != null && person.length;
    },
  },
  data() {
    return {
      isOuterLoading: false,
      isLoading: false,
      dailyTreatments: [],
      activeGuestIndex: 0,
      activeDateIndex: 0,

      activePage: "TREATMENTS",
      selectedTime: null,
      selectedPackage: null,

      activeAvailableTimes: null,

      localSelections: [],
      activeTimeOfDay: "AM",
    };
  },
  mounted() {
    let o = this;
    o.isOuterLoading = true;

    let payload = {
      fromDate: this.booking.arrivalDate,
      toDate: moment(this.booking.arrivalDate)
        .add(this.booking.numberOfNights, "d")
        .add(-1, "d")
        .format("YYYY-MM-DD"),
    };

    if (this.spaConfiguration == null) {
      store.dispatch("getSpaConfiguration").then(() => {
        store
          .dispatch("fetchSpaPackageAvailability", payload)
          .then((t) => {
            o.onSetTreatments(t);
            o.isOuterLoading = false;
          })
          .catch((e) => {
            o.isOuterLoading = false;
          });
      });
    } else {
      store
        .dispatch("fetchSpaPackageAvailability", payload)
        .then((t) => {
          o.onSetTreatments(t);
          o.isOuterLoading = false;
        })
        .catch((e) => {
          o.isOuterLoading = false;
        });
    }
  },
  methods: {
    formatDateLine1(date) {
      return moment(date).format("ddd Do");
    },
    formatDateLine2(date) {
      return moment(date).format("MMM YYYY");
    },
    onSetTimeOfDay(timeOfDay) {
      this.activeTimeOfDay = timeOfDay;
    },

    isSelected(a, t) {
      return this.localSelections.find(
        (item) =>
          item.guestIndex == this.activeGuestIndex &&
          item.dateIndex == this.activeDateIndex &&
          item.time != undefined &&
          item.time == t
      );
    },
    checkIsDisabled(t) {
      return !t.IsAvailable;
    },
    formatTime(dateTime) {
      let date = moment(dateTime);
      return date.format("HH:mm");
    },
    onClose() {
      this.$parent.$emit("close");
    },
    onNext() {
      let o = this;
      let moreGuests = this.room.guests.length > this.activeGuestIndex + 1;
      let moreDates = this.dailyTreatments.length > this.activeDateIndex + 1;
      let date = this.stayDates[this.activeDateIndex];

      if (this.activePage == "TREATMENTS") {
        this.activePage = "TIMES";
        this.activeTimeOfDay = "AM";
        this.isLoading = true;

        let found = this.localSelections.find(
          (item) =>
            item.guestIndex == this.activeGuestIndex &&
            item.dateIndex == this.activeDateIndex
        );

        let payload = {
          SessionId: this.session.Id,
          Date: date.format("YYYY-MM-DD"),
          GuestRequirements: [
            {
              Activities: [found.duration.Id],
            },
          ],
        };

        store
          .dispatch("fetchSpaPackageTimes", payload)
          .then((t) => {
            this.activeAvailableTimes = t;
            o.isLoading = false;
          })
          .catch((e) => {
            console.log(e);
            o.isLoading = false;
          });
      } else if (this.activePage == "TIMES") {
        if (moreGuests) {
          this.activeAvailableTimes = null;
          this.activeGuestIndex = this.activeGuestIndex + 1;
          this.activePage = "TREATMENTS";
        } else if (moreDates) {
          this.activeGuestIndex = 0;
          this.activeDateIndex = this.activeDateIndex + 1;
          this.activeAvailableTimes = null;
          this.activePage = "TREATMENTS";
        }
      }
    },
    onSubmit() {
      let payload = {
        leg: this.room.leg,
        selections: this.localSelections,
      };

      store.dispatch("attachSpaPackage", payload).then(() => {
        this.$parent.$emit("close");
      });
    },

    isDurationSelected(treatment, duration) {
      var item = this.localSelections.find(
        (item) =>
          item.guestIndex == this.activeGuestIndex &&
          item.dateIndex == this.activeDateIndex &&
          item.treatment.Id == treatment.Id &&
          item.duration.Id == duration.Id
      );

      return item != null;
    },
    onSelectTime(time) {
      let found = this.localSelections.find(
        (item) =>
          item.guestIndex == this.activeGuestIndex &&
          item.dateIndex == this.activeDateIndex
      );

      found.time = time;

      //I suspect we should update the object on the booking here...
    },
    onSelectTreatment(treatment, duration) {
      let item = {
        bookingType: 2,
        guestIndex: this.activeGuestIndex,
        dateIndex: this.activeDateIndex,
        treatment: treatment,
        duration: duration,
      };

      let found = this.localSelections.find(
        (item) =>
          item.guestIndex == this.activeGuestIndex &&
          item.dateIndex == this.activeDateIndex
      );

      if (found != null) {
        this.localSelections = this.localSelections.filter(
          (item) => item != found
        );
      }
      this.localSelections.push(item);
    },

    onSetTreatments(dailyActivities) {
      this.dailyTreatments = [];

      if (this.spaConfiguration != null) {
        if (dailyActivities != null) {
          for (let dai = 0; dai < dailyActivities.length; dai++) {
            let daily = dailyActivities[dai];

            var item = {
              day: daily.Date,
              treatments: [],
            };

            var treatments = this.room.rate.rateGroupRate.TreatmentGroups[0];

            var configCopy = JSON.parse(JSON.stringify(treatments));
            for (let ti = 0; ti < configCopy.Treatments.length; ti++) {
              let treatment = configCopy.Treatments[ti];

              for (let di = 0; di < treatment.Durations.length; di++) {
                let duration = treatment.Durations[di];

                let activity = daily.Items.find(
                  (item) => item.Code == duration.Code
                );

                if (activity == undefined || activity == null) {
                  treatment.Durations.pop(duration);
                } else {
                  duration.Id = activity.ID;
                  duration.Duration = activity.Length - activity.Interval;
                  duration.Price = activity.StandardPrice;
                }
              }

              if (treatment.Durations != null && treatment.Durations.length) {
                treatment.Durations = _.sortBy(
                  treatment.Durations,
                  function (item) {
                    return item.Duration;
                  }
                );
                item.treatments.push(treatment);
              }
            }

            for (let ti = 0; ti < item.treatments.length; ti++) {
              let tr = item.treatments[ti];
              var includedDuration = tr.Durations.find(
                (item) => item.IsIncluded
              );
              for (let di = 0; di < tr.Durations.length; di++) {
                let dr = tr.Durations[di];
                if (includedDuration?.Price != null) {
                  dr.PriceDifference = dr.Price - includedDuration.Price;
                } else {
                  dr.PriceDifference = dr.Price;
                }
              }
            }

            this.dailyTreatments.push(item);
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.spa-day-treatment-item {
  min-height: 250px;
  margin-bottom: 20px;
  height: calc(100% - 20px);
}

.gallery {
  height: 250px;
}

.time-slot {
  padding: 15px;
  display: block;
  background: white;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
}

.time-slot.time-slot--unavailable {
  color: rgba(66, 82, 96, 0.15);
  cursor: not-allowed;
}

.time-slot:not(.time-slot--unavailable):hover,
.time-slot.time-slot--active {
  background-color: #425260;
  color: #fff;
}

.date-selector {
  font-size: 14px;
  font-family: Montserrat;
}

.modal-button {
  background-color: #fff;
  position: relative;
  color: #000;
  border-color: #fff;
  margin-bottom: 30px !important;
}

.modal-button:after {
  border-top: 10px solid #fff;
  display: block;
  position: absolute;
  content: " ";
  bottom: -11px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  z-index: 10;
}

.modal-botton:hover,
.modal-button--active {
  background-color: #425260;
  border-color: #425260;
  color: #fff;
}

.modal-botton:hover,
.modal-button--active:after {
  border-top: 10px solid #425260;
}

.modal-close {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 10;
}

.modal-close button {
  text-indent: -9999px;
  width: 78px;
  height: 78px;
  background-position: center center;
  background-image: url("@/assets/img/booking/button-cancel-cross.svg");
  background-size: 22px 22px;
  background-repeat: no-repeat;
  min-width: unset;
}

.date-selector {
  margin-right: 20px;
}

.date-selector:last-of-type {
  margin-right: 0;
}

.date-selector button {
  width: 160px;
  padding: 20px;
  margin-right: 20px;
}

.date-selector .top {
  font-weight: bold;
  display: block;
}

.date-selector .bottom {
  font-weight: 300;
  display: block;
}

.treatments .btn-treatment {
  border: none;
  margin-right: 5px;
  padding: 15px;
  background: #eae5e3;
  text-transform: capitalize;
  min-width: 100px !important;
}

.treatments .btn-treatment:hover {
  color: #fff;
  background: #425260;
}

.treatments .btn-treatment:disabled {
  color: #000;
  cursor: not-allowed !important;
}

.btn-treatment.on {
  background: #425260;
  color: #fff;
}

.modal-price {
  display: block;
  margin-top: 5px;
  font-weight: normal;
}

.treatments .item-wrapper {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.treatments .item-description {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 15px;
  margin-bottom: 10px;
  flex-grow: 1;
  /*height: 100px;*/
}

.timeslot {
  cursor: pointer !important;
}

.timeslot--disabled,
.timeslot--disabled:hover {
  background: #ddd !important;
  color: #000 !important;
  cursor: default;
}

.time-slot {
  background: white;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.time-slot.time-slot--unavailable {
  color: rgba(66, 82, 96, 0.15);
  cursor: not-allowed;
}

.time-slot:not(.time-slot--unavailable):hover,
.time-slot.time-slot--active {
  background-color: #425260;
  color: #fff;
}

.guest-list {
  list-style: none;
  font-size: 15px;
}

.guest-list li {
  font-size: 14px;
  color: #1a1a1a;
  text-transform: uppercase;
  font-weight: bold;
}

.guest-list li.on {
  border-bottom: solid 2px #1a1a1a;
}

.current-date {
  background: #fff;
  color: rgb(66, 82, 96);
  padding: 10px;
}

.current-date.on {
  color: #fff;
  background: rgb(66, 82, 96);
  position: relative;
}

.current-date.on:after {
  border-top: 10px solid #fff;
  display: block;
  position: absolute;
  content: " ";
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  z-index: 10;
  border-top-color: rgb(66, 82, 96);
}

.modal-actions-bar {
  position: absolute;
  bottom: 15px;
}
</style>
